import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; 
import {
  Grid,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import "./Newhome.css";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useLanguage } from "../../../utils/languageContext";

const Intigrationfaq = () => {

  const { t } = useLanguage();
  const [expanded, setExpanded] = useState(null);

   const navigate = useNavigate();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const faqKeys = ["q1", "q2", "q3", "q4", "q5", "q6", "q7", "q8"];
  const leftFaqs = faqKeys.filter((_, i) => i % 2 === 0);
  const rightFaqs = faqKeys.filter((_, i) => i % 2 !== 0);

  const renderAccordion = (key, panelId) => (
    <Accordion
      key={panelId}
      expanded={expanded === panelId}
      onChange={handleChange(panelId)}
      className="faq-accordion"
    >
      <AccordionSummary className="faq-summary">
        <Typography className="faq-question">
          {t(`homepage.faq.${key}`)}
        </Typography>
        <Box className="faq-icon-wrapper">
          {expanded === panelId ? (
            <RemoveIcon className="faq-icon" />
          ) : (
            <AddIcon className="faq-icon" />
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails className="faq-details">
        <Typography>
          {t(`homepage.faq.${key.replace("q", "a")}`)}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );

  return (
    <>
      <div className="abdm-section">
        {/* 🔷 TITLE */}
        <Typography className="integration-title">
          {t("homepage.integration.title")}{" "}
          <span className="bgcolorspan">
            {t("homepage.integration.titleHighlight")}
          </span>
        </Typography>
        <Typography className="feature-subtitle">
          {t("homepage.integration.subtitle")}
        </Typography>

        {/* 🔷 DIAGRAM */}
        <Grid container spacing={4} alignItems="center" className="diagram-section">
          <img
            src="/images/Integtaionsimless.png"
            alt="Image-Programs"
            className="integration_image"
            style={{ width: "100%", height: "auto" }}
          />
        </Grid>
      </div>

      <div className="faq-section">
        <Typography className="integration-title">
          {t("homepage.faq.title")}{" "}
          <span className="bgcolorspan">
            {t("homepage.faq.titleHighlight")}
          </span>
        </Typography>
        <Typography className="feature-subtitle">
          {t("homepage.faq.subtitle")}
        </Typography>

        <Grid container spacing={3}>
          {/* LEFT */}
          <Grid size={{ xs: 12, md: 6 }}>
            {leftFaqs.map((key, index) =>
              renderAccordion(key, `left-${index}`)
            )}
          </Grid>

          {/* RIGHT */}
          <Grid size={{ xs: 12, md: 6 }}>
            {rightFaqs.map((key, index) =>
              renderAccordion(key, `right-${index}`)
            )}
          </Grid>
          
        </Grid>
          <Button
          className="faq-readmore-btn"
          onClick={() => navigate("/more-faq")}
        >
          {t("homepage.faq.Viewdetails")}
        </Button>
      </div>
    </>
  );
};

export default Intigrationfaq;
